/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __extends } from "tslib";
import { EventDispatcher } from '../events/EventDispatcher';
import { somewhatImplemented, release } from '@awayfl/swf-loader';
import { Errors } from '@awayfl/avm2';
// Class: GameInput
var GameInput = /** @class */ (function (_super) {
    __extends(GameInput, _super);
    function GameInput() {
        return _super.call(this, undefined) || this;
    }
    Object.defineProperty(GameInput, "numDevices", {
        // JS -> AS Bindings
        // AS -> JS Bindings
        // static _numDevices: number /*int*/;
        // static _isSupported: boolean;
        get: function () {
            release || somewhatImplemented('public flash.ui.GameInput::get numDevices');
            return 0;
            // return this._numDevices;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameInput, "isSupported", {
        get: function () {
            release || somewhatImplemented('public flash.ui.GameInput::get isSupported');
            return false;
        },
        enumerable: true,
        configurable: true
    });
    GameInput.getDeviceAt = function (index /*int*/) {
        index = index | 0;
        release || somewhatImplemented('public flash.ui.GameInput::static getDeviceAt');
        this.sec.throwError('RangeError', Errors.ParamRangeError, 'index');
        return null;
    };
    // Called whenever the class is initialized.
    GameInput.classInitializer = null;
    // List of static symbols to link.
    GameInput.classSymbols = null; // [];
    // List of instance symbols to link.
    GameInput.instanceSymbols = null; // [];
    return GameInput;
}(EventDispatcher));
export { GameInput };
